import React,{useState} from 'react'
import { Link } from 'react-router-dom';
import '../../src/css/BottomHeader.css';
import { Row, Col, } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeartBroken } from "@fortawesome/free-solid-svg-icons";
import { faUserSecret, faUser,faSearch, faCartShopping } from '@fortawesome/free-solid-svg-icons';

import LagerLogo from '../../src/images/LagerLogo.png'
import AKLogo from '../../src/images/AKheader.png'



const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
   <div style={{
      backgroundColor: '#fff',
      height: '75px',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '0.8em',
      // paddingRight: '2em',
      justifyContent: 'space-between'
    }}>
      
      {/* Logo */}
      <div style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
        <a href='/' style={{ height: '95%', objectFit: 'contain' }} >
          <img 
            src={AKLogo} 
            alt="Logo" 
            style={{ height: '85%', objectFit: 'contain' }} 
          />
        </a>
      </div>

      <button 
        className="navbar-toggler d-lg-none" 
        type="button" 
        onClick={toggleMenu}
        style={{
          border: 'none',
          background: 'transparent',
          fontSize: '1.5rem',
          cursor: 'pointer'
        }}
      >
        &#9776; {/* hamburger icon */}
      </button>

      {/* Navigation Menu */}
      <ul className={`nav text-uppercase ${isOpen ? 'd-flex' : 'd-none'} d-lg-flex`} 
        style={{ 
          height: '100%', 
          alignItems: 'center', 
          marginBottom: 0,
          flexDirection: isOpen ? 'column' : 'row',
          position: isOpen ? 'absolute' : 'static',
          top: '65px',
          right: 0,
          backgroundColor: '#fff',
          padding: isOpen ? '1em' : 0,
          boxShadow: isOpen ? '0 4px 6px rgba(0,0,0,0.1)' : 'none',
          zIndex: 1000
        }}>
        <li className="nav-item nav-link"><a className='textColor' href="/">Home</a></li>
        <li className="nav-item nav-link"><a className='textColor' href="/about">About Us</a></li>
        <li className="nav-item nav-link"><a className='textColor' href="/product-list">Products</a></li>
        <li className="nav-item nav-link">Security Solutions</li>
        <li className="nav-item nav-link"><a className='textColor' href="/contact">Contact Us</a></li>
      </ul>

    </div>
  )
}

export default Header